import { get,} from "services/BaseClient/Client"
import headers from "services/BaseClient/Headers.json";
import { DataResponse } from "services/BaseClient/BaseResponseModel";
import endpoints from "./EndPoints";
import { CreateUrlFilter } from "helpers/CreateURLFilter";


export const getInvoiceListFitler = async (filter:any): Promise<DataResponse<any>> => {
  const query = filter?CreateUrlFilter(filter):null
    const url = `${endpoints.getInvoiceList}${query?`?${query}`:""}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };
  export const getInvoiceDetails = async (invoiceId:number): Promise<DataResponse<any>> => {
   
      const url = `${endpoints.getInvoiceDetails}/${invoiceId}`;
      const config = headers.content_type.application_json;
      return get<DataResponse<any>>(url, config);
    };
  